import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { DAYS_PER_WEEK } from "apps/project-iq/components/VaultMeetingsDialog/VaultMeetingsDialog.constants";
import { designTokens } from "theme/customTheme";

const DATE_PILL_PADDING_VERTICAL = "2px";
const DAY_COLUMN_MIN_WIDTH = "120px";
const GRID_MIN_HEIGHT = "360px";

export const useVaultMeetingsWeekGridStyles = makeStyles({
  scroller: {
    overflowX: "auto",
    flex: 1,
    minHeight: GRID_MIN_HEIGHT,
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: projectIqTokens.shadowSm,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: `repeat(${DAYS_PER_WEEK}, minmax(${DAY_COLUMN_MIN_WIDTH}, 1fr))`,
    minHeight: "100%",
  },
  dayColumn: {
    minWidth: 0,
    boxSizing: "border-box",
    padding: designTokens.spacing[2],
    borderLeft: `1px solid ${projectIqTokens.line2}`,
  },
  dayColumnFirst: {
    borderLeft: "none",
  },
  dayName: {
    margin: `0 0 ${designTokens.spacing[1]}`,
    textAlign: "center",
    fontSize: designTokens.fontSize.xs,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.muted,
  },
  dateRow: {
    margin: `0 0 ${designTokens.spacing[2]}`,
    textAlign: "center",
  },
  date: {
    display: "inline-block",
    padding: `${DATE_PILL_PADDING_VERTICAL} ${designTokens.spacing[2]}`,
    borderRadius: designTokens.borderRadius.full,
    fontSize: designTokens.fontSize["2xs"],
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink2,
  },
  dateToday: {
    backgroundColor: projectIqTokens.ink,
    color: projectIqTokens.card,
  },
  meetingList: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
    margin: 0,
    padding: 0,
    listStyleType: "none",
  },
});
